/**
 * Push notification filter field definitions for the shared FilterBuilder.
 * Mirrors Python AVAILABLE_FILTERS from sections/base/components.py.
 */
import {
  COMMON_FILTER_OPERATORS,
  BOOLEAN_OPTIONS,
  PLATFORM_OPTIONS_WITH_WEB,
  type FilterFieldMeta,
} from '@/lib/filters';

export const PUSH_FILTER_FIELDS = [
  { value: 'device_id', label: 'device_id' },
  { value: 'app_version', label: 'app_version' },
  { value: 'platform', label: 'platform' },
  { value: 'country', label: 'country' },
  { value: 'is_premium', label: 'is_premium' },
  { value: 'is_web_to_app', label: 'is_web_to_app' },
  { value: 'campaign_name', label: 'campaign_name' },
  { value: 'traffic_source', label: 'traffic_source' },
  { value: 'clicked_push', label: 'clicked_push' },
  { value: 'clicked_push_id', label: 'clicked_push_id' },
  { value: 'purchase_structure', label: 'purchase_structure' },
  { value: 'app_open_count', label: 'app_open_count' },
  { value: 'retention_days', label: 'retention_days' },
] as const;

export const PUSH_FILTER_OPERATORS = COMMON_FILTER_OPERATORS;

export const PUSH_FILTER_FIELD_META: FilterFieldMeta = {
  device_id:              { type: 'text', placeholder: 'Enter device ID' },
  app_version:            { type: 'text', placeholder: 'e.g., 1.2.3' },
  platform:               { type: 'dropdown', options: [...PLATFORM_OPTIONS_WITH_WEB] },
  country:                { type: 'text', placeholder: 'e.g., US' },
  is_premium:             { type: 'dropdown', options: [...BOOLEAN_OPTIONS] },
  is_web_to_app:          { type: 'dropdown', options: [...BOOLEAN_OPTIONS] },
  campaign_name:          { type: 'text', placeholder: 'Enter campaign name' },
  traffic_source:         { type: 'text', placeholder: 'Enter traffic source' },
  clicked_push:           { type: 'text', placeholder: 'Enter push ID' },
  clicked_push_id:   { type: 'text', placeholder: 'Enter push variant' },
  purchase_structure:     { type: 'text', placeholder: 'Enter purchase structure' },
  app_open_count:         { type: 'text', placeholder: 'Enter app open count' },
  retention_days:         { type: 'text', placeholder: 'Enter retention days' },
};
